import { type Components, type Theme } from '@mui/material/styles'

/**
 * A single on/off state the operator can flip in place.
 *
 * Sized down from the MUI default so a long column of them reads as a list of
 * settings rather than a stack of controls, and given a filled track when on so
 * the enabled rows are legible at a glance from across the section.
 */
export const MuiSwitchOverride: Components<Theme>['MuiSwitch'] = {
  defaultProps: {
    size: 'small',
    color: 'primary',
    disableRipple: true,
  },
  styleOverrides: {
    switchBase: ({ theme }) => ({
      '&.Mui-checked + .MuiSwitch-track': {
        backgroundColor: theme.palette.primary.main,
        // MUI leans on opacity for the checked track, which reads as washed out
        // against the paper surface these sit on.
        opacity: 1,
      },
      '&.Mui-disabled:not(.Mui-checked) + .MuiSwitch-track': {
        backgroundColor: theme.palette.action.disabled,
        opacity: 1,
      },
      // On but not changeable — dimmed rather than greyed. A grey track here would
      // report a product flag as off when it is on, which is what makes a locked
      // package's enabled product flags look switched off.
      '&.Mui-disabled.Mui-checked + .MuiSwitch-track': {
        backgroundColor: theme.palette.primary.main,
        opacity: 0.45,
      },
      // Left at full strength when checked, so the thumb does not wash out against
      // the dimmed track above.
      '&.Mui-disabled:not(.Mui-checked) .MuiSwitch-thumb': {
        color: theme.palette.background.paper,
      },
    }),
    track: ({ theme }) => ({
      backgroundColor: theme.palette.action.disabled,
      opacity: 1,
    }),
  },
}
